import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`BTW, I also love cooking...`}</p>
    <h1>{`Why`}</h1>
    <p>{`When you are stuck at home with limit access to restaurants, or when you just realized how many sugars/oil (unfavorable gradients) are put in your favorable food, or when you want to optimize the ancient traditional way of cooking arts, you start to think about create a channel for cooking at home.`}</p>
    <p>{`Also acuquired some video editing skill recently: why not use them?`}</p>
    <h1>{`Background`}</h1>
    <p>{`As Szechuanese, oil-spicy fragrant is my favorite. I don't like most raw flavor from meat, blood or guts so I try my best to either get rid of them or combine them with different smell and flavor e.g. all kinds of spice and herbs.`}</p>
    <p>{`As an engineer, I don't like complicate or unoptimized way of cooking. I feel it wastes energy and could be greener. I don't pursue ultimate flavor but balanced fastest way to produce plausible flavor close to groundtruth (so-called authentic dish).`}</p>
    <p>{`Having limited time, this post will just serve as intro and gateway to all videos shared:`}</p>
    <h1>{`Channels`}</h1>
    <h2>{`Episode -1`}</h2>
    <blockquote>
      <p parentName="blockquote">{`测试测试！`}</p>
    </blockquote>
    <p>{`Test camera setup and my video production "pipeline" 😄. Cooked Curry Salmon and Pickle Scrambles Egg. `}</p>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/mvKeswBt5S4" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2>{`Episode 0`}</h2>
    <blockquote>
      <p parentName="blockquote">{`简单粗暴的麻辣蘸料是生存的第一步`}</p>
    </blockquote>
    {
      /* Simply Rude Works in The Wild */
    }
    {
      /* Don't be afraid of MicroWave */
    }
    {
      /* Soul level chili oil, in 2 min */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      